<template>
    <header class="header">
        <app-date-range-statistic-filter
            data-entity="statistics"
        ></app-date-range-statistic-filter>

        <MonitoringTrafficNetworkFilter />

        <button class="btn btn-extra-round btn-primary" @click="emitFilterLoad">
            {{ $t("message.generics.message.fetchData") }}
        </button>
    </header>
</template>

<script>
import LocalEstableshimentFilter from "@components/filters/LocalEstableshimentFilter";
import AppAdvertisingFilter from "@components/filters/AdvertisingFilter";
import AppDateRangeStatisticFilter from "@components/filters/DateRangeStatisticFilter";
import EventBus from "@packages/event-bus";
import MonitoringTrafficNetworkFilter from "../MonitoringTrafficNetworkFilter.vue";

export default {
    components: {
        AppDateRangeStatisticFilter,
        AppAdvertisingFilter,
        LocalEstableshimentFilter,
        MonitoringTrafficNetworkFilter
    },
    methods: {
        emitFilterLoad() {
            EventBus.$emit("STATISTICS_FILTER_RELOAD");
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.header {
    height: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: center;
}
</style>
